import Link from 'next/link'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'

const BOX_SX = {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'start',
    gap: 1,
    flexDirection: 'row',
    textDecoration: 'none',
}

const LABEL_SX = {
    color: 'white',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: 'MonaSansCondensed, sans-serif',
}

interface IconLinkProps {
    label: string | ReactNode
    icon: ReactNode
    href: string
    [key: string]: any
}

const IconLink = ({ label, icon, href, ...rest }: IconLinkProps) => {
    return (
        <Link href={href} style={{ textDecoration: 'none' }}>
            <Box sx={BOX_SX} {...rest}>
                {icon}
                <Typography sx={LABEL_SX}>
                    {label}
                </Typography>
            </Box>
        </Link>
    )
}

export default IconLink


